import { useTranslation } from 'react-i18next';
import { useErrors } from '../../../hooks/useErrors';
import { Description } from 'pages/Common/components/Description';

type DescriptionInputProps = {
  description?: string;
  aiDescription?: string;
  onChange: (value: string) => void;
};

export const DescriptionInput = ({
  description,
  aiDescription,
  onChange,
}: DescriptionInputProps) => {
  const { t } = useTranslation();

  const { clearError, validate, error } = useErrors('description');

  const handleChange = (v: string) => {
    const trimmed = v.trim();
    if ((description || trimmed) && description !== trimmed) {
      onChange(trimmed);
      clearError();
    }
  };

  return (
    <Description
      label={t('Description')}
      description={description || ''}
      aiDescription={aiDescription}
      onChange={handleChange}
      inputProps={{
        margin: true,
        validate,
      }}
      error={error}
    />
  );
};
